// CRA embeds REACT_APP_* at build time. Vercel must set REACT_APP_API_URL
// (or rely on this production fallback) so the browser does not call localhost.
const DEFAULT_API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://gonggu-web.onrender.com'
    : 'http://localhost:8080';

export const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;
